$(function () {
  let section = $('.pagar-producto')
  if (section.get(0) == null) {
    return
  }
  var stripeHelper = null;

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      formaPago: "tarjeta",
      producto: {},
      paisesListado: [],
      pais: null,
      estado: null,
      agregarCupon: false,
      setupIntentAch: null,
      cuponCodigo: null,
      cupon: null,
    },
    mounted() {
      this.producto = productoJson
      this.initStripe()
      this.getPaises()
      this.validar()
    },
    methods: {
      getNextRenovacion(){
        let ahora = dayjs()
        if(this.producto.tipo == 'anual'){
          ahora = ahora.add(1, 'year')
        }
        else{
          ahora = ahora.add(1, 'month')
        }
        return ahora.format('DD MMMM YYYY')
      },
      getDescuentoCupon(){
        if(this.cupon != null){
          if(this.cupon.tipo == 'c'){
            return this.cupon.cantidad
          }
          let descuento = (this.cupon.cantidad / 100) * this.producto.precio
          return descuento
        }
        return 0
      },
      buscarCupon(e){
        e.preventDefault()
        if(this.cupon != null){
          this.cupon = null
          this.cuponCodigo = null
          return
        }
        if(this.cuponCodigo == null || this.cuponCodigo.length === 0){
          return
        }
        let vue = this
        $("#btnCupon").loader("show")
        axios.get("/buscar-cupon", {
          params: {codigo: this.cuponCodigo,
          producto_id: productoJson.id}
        }).then(respuesta => {
          $("#btnCupon").loader("hide")
          if(respuesta.data.cupon != null){
            vue.cupon = respuesta.data.cupon
            swal("Cupón agregado", "", "success")
          }
          else{
            swal("Cupón no válido. Intenta con otro código", "", "info")
          }
        }).catch((error) => {
          $("#btnCupon").loader("hide")
          swal("Ocurrió un error inesperado", "", "info")
          console.error(error)
        })
      },
      initStripe(){
        stripeHelper = new StripeHelper(StripePublic)
        this.actualizarStripeElement()
      },
      actualizarStripeElement(){
        this.$nextTick(() => {
          stripeHelper.initForm("#card-number-element",
            "#card-expiry-element", "#card-cvc-element")
        })
      },
      actualizarPais(){
        this.estado = null
        this.validar()
      },
      actualizarEstado(){
        this.validar()
      },
      getPaises(){
        let vue = this
        axios.get("https://countriesnow.space/api/v0.1/countries/states").then(respuesta => {
          vue.paisesListado = respuesta.data.data.map(item => ({
            label: item.name,
            code: item.name,
            states: item.states.map(item2 => ({
              label: item2.name,
              code: item2.name,
            }))
          }))

          if(paisSelected != null && paisSelected.length > 0){
            let paisEncontrado = respuesta.data.data.find(item => {
              return item.iso2.toLowerCase() == paisSelected.toLowerCase()
                || item.name.toLowerCase() == paisSelected.toLowerCase()
            })
            if(paisEncontrado != null){

              let estadoEncontrado = paisEncontrado.states.find(item => {
                return item.state_code.toLowerCase() == estadoSelected.toLowerCase()
                  || item.name.toLowerCase() == estadoSelected.toLowerCase()
              })

              vueApp.pais = {
                label: paisEncontrado.name,
                code: paisEncontrado.name,
                states: paisEncontrado.states.map(item2 => ({
                  label: item2.name,
                  code: item2.name,
                }))
              }

              if(estadoEncontrado != null){
                vueApp.estado = {
                  label: estadoEncontrado.name,
                  code: estadoEncontrado.name,
                }
              }

            }
            paisSelected = null
            estadoSelected = null
          }
          vue.validar()
        })
      },
      validar(){
        this.$nextTick(() => {
          $('#payment-form').validarForm((form) => {
            vueApp.procesarMetodoPago()
          })
        })
      },
      procesarMetodoPago(){
        if(this.formaPago == "tarjeta"){
          this.procesarPago()
        }
        else{
          this.generarPagoAch()
        }
      },
      generarPagoAch(formData){
        $("#btnPagar").loader("show")
        let $formData = new FormData(document.querySelector("#payment-form"))
        let vue = this
        axios
          .post("/generar-metodo-pago-ach", $formData)
          .then((respuesta) => {
            $("#btnPagar").loader("hide")
            if (respuesta.data.error) {
              swal(respuesta.data.error, "", "info")
              return
            }
            vue.setupIntentAch = respuesta.data
            vue.showSelectBankAch()
          })
          .catch((error) => {
            $("#btnPagar").loader("hide")
            swal("Ocurrió un error inesperado", "", "info")
            console.error(error)
          })
      },
      async procesarPago(){
        $("#btnPagar").loader("show")
        let $formData = new FormData(document.querySelector("#payment-form"))
        if(this.formaPago == "tarjeta"){
          let paymentId = await stripeHelper.tokenizar()
          if(paymentId == null){
            $("#btnPagar").loader("hide")
            return
          }
          $formData.append("payment_method_id", paymentId)
        }
        else{
          $formData.append("setup_intent_id", this.setupIntentAch.setup_intent_id)
        }
        $formData.append("producto_id", this.producto.id)
        if(this.cupon != null){
          $formData.append("cupon_id", this.cupon.id)
        }
        axios
          .post("/procesar-pago", $formData)
          .then((respuesta) => {
            $("#btnPagar").loader("hide")
            if (respuesta.data.error) {
              swal(respuesta.data.error, "", "info")
              return
            }
            $("#btnPagar").loader("show")
            location.href = "/pedido/" + respuesta.data.hash
              // swal(respuesta.data.mensaje, "", "success", 4000)
              //   .finally( () => {
              // })
          })
          .catch((error) => {
            $("#btnPagar").loader("hide")
            swal("Ocurrió un error inesperado", "", "info")
            console.error(error)
          })
      },
      async showSelectBankAch(){
        $("#btnPagar").loader("show")
        try{
          let {setupIntent, error} = await stripeHelper.collectBankAccountForSetup(this.setupIntentAch.cliente_secreto,
            this.setupIntentAch.cliente_nombre,
            this.setupIntentAch.cliente_correo_electronico)
          $("#btnPagar").loader("hide")
          if (error) {
            swal(error.message, "", "error")
          }
          else if(setupIntent.status === 'canceled'){
            swal("Ocurrió un error al vincular la cuenta, por favor intente de nuevo", "", "info")
          }
          else if (setupIntent.status === 'requires_payment_method') {
            // Customer canceled the hosted verification modal. Present them with other
            // payment method type options.
            swal("Ocurrió un error al vincular la cuenta, por favor intente de nuevo", "", "info")
          }
          else {
            // We collected an account - possibly instantly verified, but possibly
            // manually-entered. Display payment method details and mandate text
            // to the customer and confirm the intent once they accept
            // the mandate.
            this.procesarPago()
          }
        }
        catch (e){
          $("#btnPagar").loader("hide")
          swal("Ocurrió un error al seleccionar el banco", "", "error")
        }
      },
    }
  });



});
